import { BuscaEleitoresDiscentes } from './discentes';
import { BuscaEleitoresDocentes } from './docentes';
import { BuscaEleitoresTecnicos } from './tecnicos';
import { BuscaEleitoresType } from '../../types';
import { FunctionComponent } from 'react';
import { TipoGrupoEleitoresEnum } from '../../enums';

const BuscaEleitores: FunctionComponent<BuscaEleitoresType> = ({ handleLimparBusca, setResultado, setLoading, tipo }) => {
  switch (tipo.key) {
    case TipoGrupoEleitoresEnum.DOCENTE.key:
      return (
        <BuscaEleitoresDocentes handleLimparBusca={handleLimparBusca} setResultado={setResultado} setLoading={setLoading} />
      );
    case TipoGrupoEleitoresEnum.TECNICO_ADMINISTRATIVO.key:
      return (
        <BuscaEleitoresTecnicos handleLimparBusca={handleLimparBusca} setResultado={setResultado} setLoading={setLoading} />
      );
    case TipoGrupoEleitoresEnum.DISCENTE.key:
      return (
        <BuscaEleitoresDiscentes handleLimparBusca={handleLimparBusca} setResultado={setResultado} setLoading={setLoading} />
      );
    default:
      return <></>;
  }
};

export default BuscaEleitores;
